var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComboChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BD02B785-7766-488A-A48C-F582EC743EAD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.4,0.00018 C6.3954,0.00018 7.2,0.80658 7.2,1.80018 L7.2,52.20018 C7.2,53.19378 6.3954,54.00018 5.4,54.00018 L1.8,54.00018 C0.8046,54.00018 0,53.19378 0,52.20018 L0,1.80018 C0,0.80658 0.8046,0.00018 1.8,0.00018 L5.4,0.00018 Z M14.04486,17.82 C15.04026,17.82 15.84486,18.6264 15.84486,19.62 L15.84486,52.02 C15.84486,53.0136 15.04026,53.82 14.04486,53.82 L10.44486,53.82 C9.45126,53.82 8.64486,53.0136 8.64486,52.02 L8.64486,19.62 C8.64486,18.6264 9.45126,17.82 10.44486,17.82 L14.04486,17.82 Z M23.04486,35.82 C24.04026,35.82 24.84486,36.6264 24.84486,37.62 L24.84486,52.02 C24.84486,53.0136 24.04026,53.82 23.04486,53.82 L19.44486,53.82 C18.45126,53.82 17.64486,53.0136 17.64486,52.02 L17.64486,37.62 C17.64486,36.6264 18.45126,35.82 19.44486,35.82 L23.04486,35.82 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41220447,0.00018 C6.40580447,0.00018 7.21220447,0.80658 7.21220447,1.80018 L7.21220447,52.20018 C7.21220447,53.19378 6.40580447,54.00018 5.41220447,54.00018 L1.81220447,54.00018 C0.816804472,54.00018 0.0122044719,53.19378 0.0122044719,52.20018 L0.0122044719,1.80018 C0.0122044719,0.80658 0.816804472,0.00018 1.81220447,0.00018 L5.41220447,0.00018 Z M14.0570645,17.82 C15.0524645,17.82 15.8570645,18.6264 15.8570645,19.62 L15.8570645,52.02 C15.8570645,53.0136 15.0524645,53.82 14.0570645,53.82 L10.4570645,53.82 C9.46166447,53.82 8.65706447,53.0136 8.65706447,52.02 L8.65706447,19.62 C8.65706447,18.6264 9.46166447,17.82 10.4570645,17.82 L14.0570645,17.82 Z M23.0570645,35.82 C24.0524645,35.82 24.8570645,36.6264 24.8570645,37.62 L24.8570645,52.02 C24.8570645,53.0136 24.0524645,53.82 23.0570645,53.82 L19.4570645,53.82 C18.4616645,53.82 17.6570645,53.0136 17.6570645,52.02 L17.6570645,37.62 C17.6570645,36.6264 18.4616645,35.82 19.4570645,35.82 L23.0570645,35.82 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.1-WebPageBuilder-EmptyWidgets",
    transform: "translate(-849.000000, -322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pie",
    transform: "translate(707.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Combo-Chart/40dp",
    transform: "translate(112.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-2)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.000000, -9.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(38.142936, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-4)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-38.142936, -9.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComboChart);
export default __webpack_public_path__ + "static/media/comboChart.c4138318567e2b80e6d040bebf282dd6.svg";
export { ForwardRef as ReactComponent };